package com.evoapps.evoshift.ui.kiosk

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.TabletAndroid
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import com.evoapps.evoshift.di.diViewModel
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.viewmodels.KioskPairViewModel
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoTextField
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.kiosk_pair_button
import evoshift.composeapp.generated.resources.kiosk_pair_code
import evoshift.composeapp.generated.resources.kiosk_pair_confirm
import evoshift.composeapp.generated.resources.kiosk_pair_name
import evoshift.composeapp.generated.resources.kiosk_pair_text
import org.jetbrains.compose.resources.stringResource

/**
 * SH-107, on the sign-in screen: "Pair as a clock-in tablet". Opens a dialog for the manager's
 * one-time code; once paired, the device signs in as the tablet and App.kt shows the kiosk.
 */
@Composable
fun KioskPairButton(modifier: Modifier = Modifier) {
    var open by remember { mutableStateOf(false) }
    TextButton(onClick = { open = true }, modifier = modifier) {
        Text(stringResource(Res.string.kiosk_pair_button), color = LightGold.copy(alpha = 0.8f))
    }
    if (open) KioskPairDialog(onDismiss = { open = false })
}

@Composable
fun KioskPairDialog(onDismiss: () -> Unit) {
    val viewModel: KioskPairViewModel = diViewModel()
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    EvoDialog(
        title = stringResource(Res.string.kiosk_pair_button),
        subtitle = stringResource(Res.string.kiosk_pair_text),
        icon = Icons.Default.TabletAndroid,
        onDismiss = onDismiss,
        dismissible = !state.isPairing,
        confirm = DialogAction(
            stringResource(Res.string.kiosk_pair_confirm),
            viewModel::pair,
            enabled = state.canPair,
            loading = state.isPairing
        )
    ) {
        EvoTextField(
            value = state.code,
            onValueChange = viewModel::code,
            label = stringResource(Res.string.kiosk_pair_code),
            capitalization = KeyboardCapitalization.Characters,
            error = state.error?.asString()
        )
        EvoTextField(
            value = state.name,
            onValueChange = viewModel::name,
            label = stringResource(Res.string.kiosk_pair_name),
            imeAction = ImeAction.Done,
            keyboardActions = KeyboardActions(onDone = { viewModel.pair() })
        )
    }
}
